import React, { useState } from "react";
import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Icon,
  useColorModeValue,
  Flex,
  Badge,
  Image,
  IconButton,
  Stack,
} from "@chakra-ui/react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaPlane,
  FaUtensils,
  FaWifi,
  FaCrown,
} from "react-icons/fa";

const BusinessPromoKL = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  //   const bgGradient = useColorModeValue(
  //     "linear(to-br, blue.50, purple.50)",
  //     "linear(to-br, gray.900, blue.900)",
  //   );

  const cardBg = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.700", "gray.200");
  const accentColor = useColorModeValue("blue.600", "blue.300");

  const features = [
    {
      icon: FaPlane,
      title: "Privacy without isolation",
      description:
        "The cabin layout offers a balance between openness and privacy. Seat shells and dividers reduce disturbance from surrounding passengers, creating a calm environment suitable for working, relaxing, or sleeping.",
      color: "blue.500",
      image:
        "https://travel-time.ro/images/af-kl/kl-feb-2026/business-class/kc1.jpg",
    },
    {
      icon: FaWifi,
      title: "Full-flat seats",
      description:
        "seats convert into beds and offer privacy with screens or partitions.",
      color: "green.500",
      image:
        "https://travel-time.ro/images/af-kl/kl-feb-2026/business-class/kc2.jpg",
    },
    {
      icon: FaWifi,
      title: "Quality cuisine and drinks",
      description:
        "refined meal service and a selection of drinks throughout long-haul flights.",
      color: "green.500",
      image:
        "https://travel-time.ro/images/af-kl/kl-feb-2026/business-class/kc3.jpg",
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  return (
    <Box minH="100vh" py={{ base: 10, md: 16 }}>
      <Container maxW="7xl">
        {/* Header with Logo */}
        <VStack spacing={6} mb={12} textAlign="center">
          <Image
            src="https://travel-time.ro/images/af-kl/KLM-logo.png"
            alt="Air France Logo"
            h={{ base: "80px", md: "120px" }}
            w="auto"
            maxW={{ base: "250px", md: "350px" }}
            objectFit="contain"
          />
          {/* <Badge
            colorScheme="blue"
            px={4}
            py={2}
            borderRadius="full"
            fontSize={{ base: "xs", md: "sm" }}
            fontWeight="bold"
          >
            PREMIUM EXPERIENCE
          </Badge> */}
          <Text
            fontSize={{ base: "3xl", md: "5xl", lg: "6xl" }}
            fontWeight="bold"
            bgColor="blue.600"
            bgClip="text"
            lineHeight="shorter"
          >
            Travelling in KLM World Business Class
          </Text>
        </VStack>

        {/* Carousel Container */}
        <Box w="100%" mb={12}>
          <Box
            position="relative"
            w={{ base: "95%", md: "85%", lg: "75%" }}
            mx="auto"
            overflow="hidden"
          >
            {/* Carousel Wrapper */}
            <Box
              position="relative"
              borderRadius="3xl"
              overflow="hidden"
              boxShadow="2xl"
              bg={cardBg}
            >
              {/* Image Container */}
              <Box
                position="relative"
                h={{ base: "400px", md: "500px", lg: "600px" }}
                overflow="hidden"
              >
                <Image
                  src={features[currentSlide].image}
                  alt={features[currentSlide].title}
                  w="full"
                  h="full"
                  objectFit="cover"
                  transition="all 0.5s ease"
                />

                {/* Gradient Overlay */}
                <Box
                  position="absolute"
                  bottom={0}
                  left={0}
                  right={0}
                  h="60%"
                  bgGradient="linear(to-t, rgba(0,0,0,0.8), transparent)"
                />

                {/* Icon Badge
                <Flex
                  position="absolute"
                  top={6}
                  left={6}
                  bg="whiteAlpha.900"
                  borderRadius="full"
                  p={3}
                  boxShadow="lg"
                >
                  <Icon
                    as={features[currentSlide].icon}
                    boxSize={6}
                    color={features[currentSlide].color}
                  />
                </Flex> */}

                {/* Content Overlay */}
                <VStack
                  position="absolute"
                  bottom={0}
                  left={0}
                  right={0}
                  p={{ base: 6, md: 8 }}
                  align="stretch"
                  spacing={3}
                >
                  <Text
                    fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                    fontWeight="bold"
                    color="white"
                  >
                    {features[currentSlide].title}
                  </Text>
                  <Text
                    fontSize={{ base: "md", md: "lg" }}
                    color="whiteAlpha.900"
                    lineHeight="tall"
                  >
                    {features[currentSlide].description}
                  </Text>
                </VStack>
              </Box>

              {/* Navigation Buttons */}
              <IconButton
                icon={<FaChevronLeft />}
                position="absolute"
                left={4}
                top="50%"
                transform="translateY(-50%)"
                onClick={prevSlide}
                bg="whiteAlpha.900"
                _hover={{ bg: "white" }}
                borderRadius="full"
                size={{ base: "md", md: "lg" }}
                aria-label="Previous slide"
                zIndex={2}
              />
              <IconButton
                icon={<FaChevronRight />}
                position="absolute"
                right={4}
                top="50%"
                transform="translateY(-50%)"
                onClick={nextSlide}
                bg="whiteAlpha.900"
                _hover={{ bg: "white" }}
                borderRadius="full"
                size={{ base: "md", md: "lg" }}
                aria-label="Next slide"
                zIndex={2}
              />

              {/* Dots Navigation */}
              <HStack
                position="absolute"
                bottom={4}
                left="50%"
                transform="translateX(-50%)"
                spacing={2}
                zIndex={2}
              >
                {features.map((_, index) => (
                  <Box
                    key={index}
                    w={{ base: "8px", md: "10px" }}
                    h={{ base: "8px", md: "10px" }}
                    borderRadius="full"
                    bg={currentSlide === index ? "white" : "whiteAlpha.500"}
                    cursor="pointer"
                    onClick={() => setCurrentSlide(index)}
                    transition="all 0.3s"
                    _hover={{ bg: "white" }}
                  />
                ))}
              </HStack>
            </Box>
          </Box>
        </Box>

        {/* Content Section */}
        <VStack
          spacing={8}
          w={{ base: "95%", md: "85%", lg: "75%" }}
          mx="auto"
          mb={12}
        >
          <VStack spacing={6} align="stretch">
            <Text
              fontSize={{ base: "2xl", md: "3xl" }}
              fontWeight="bold"
              color={accentColor}
              textAlign="center"
            >
              KLM – World Business Class
            </Text>

            <Stack
              spacing={5}
              fontSize={{ base: "md", md: "lg" }}
              color={textColor}
              lineHeight="tall"
            >
              <Text>
                KLM’s World Business Class is the flagship long-haul product,
                built around comfort, privacy, and high-quality service. On
                long-haul flights, this class delivers a premium travel
                experience with full-flat seats and elevated onboard services
              </Text>

              <Text>
                World Business Class is designed for travellers who prioritise
                space, rest, and personalized service across intercontinental
                travel.
              </Text>
            </Stack>
          </VStack>

          {/* CTA Button */}
          <Box
            as="a"
            href="https://www.klm.ro/information/travel-class-extra-options/business-class"
            target="_blank"
            rel="noopener noreferrer"
            bg="blue.600"
            color="white"
            px={{ base: 6, md: 8 }}
            py={{ base: 3, md: 4 }}
            borderRadius="full"
            fontSize={{ base: "md", md: "lg" }}
            fontWeight="bold"
            transition="all 0.3s ease"
            textDecoration="none"
            display="inline-block"
            _hover={{
              bg: "blue.700",
              transform: "translateY(-2px)",
              boxShadow: "xl",
              textDecoration: "none",
            }}
          >
            More details for KLM World Business Class
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default BusinessPromoKL;
